// extracted by mini-css-extract-plugin
module.exports = {"course-list-header":"course-list_course-list-header__oXqRd"};